import { Link } from "react-router-dom";
import { Mail, ArrowRight } from "lucide-react";
import { COMPANY, NAV_LINKS, PRODUCT_CATEGORIES } from "@/data/content";
import { GoldDivider } from "@/components/common";

const COMPANY_LINKS = [
  { label: "About Prince Trading Impex", to: "/about" },
  { label: "Star Export House", to: "/about" },
  { label: "Trade Capabilities", to: "/trade-capabilities" },
  { label: "Private Label Support", to: "/products" },
  { label: "Contact", to: "/contact" },
];

const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden hero-navy-gradient text-white">
      <div className="gold-hairline" />
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14 sm:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          {/* Brand */}
          <div className="md:col-span-4">
            <Link to="/" className="inline-flex items-center gap-3" data-testid="footer-logo-link">
              <img src={COMPANY.logo} alt="Prince Trading Impex" className="h-12 w-12 object-contain" />
              <span className="font-serif text-2xl leading-tight">
                Prince Trading <span className="gold-text-gradient">Impex</span>
              </span>
            </Link>
            <p className="mt-5 max-w-sm font-sans text-sm leading-relaxed" style={{ color: "var(--pt-muted-on-navy)" }}>
              {COMPANY.footerBlurb}
            </p>
            <a
              data-testid="footer-email-link"
              href={`mailto:${COMPANY.email}`}
              className="mt-6 inline-flex items-center gap-2 font-sans text-sm font-medium text-gold-soft hover:text-white transition-colors"
            >
              <Mail size={16} /> {COMPANY.email}
            </a>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-2">
            <h4 className="font-sans text-xs font-semibold uppercase tracking-[0.18em] text-gold">Explore</h4>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="font-sans text-sm transition-colors" style={{ color: "var(--pt-muted-on-navy)" }}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div className="md:col-span-3">
            <h4 className="font-sans text-xs font-semibold uppercase tracking-[0.18em] text-gold">Products</h4>
            <ul className="mt-5 space-y-3">
              {PRODUCT_CATEGORIES.map((p) => (
                <li key={p.id}>
                  <Link to="/products" className="font-sans text-sm transition-colors" style={{ color: "var(--pt-muted-on-navy)" }}>
                    {p.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div className="md:col-span-3">
            <h4 className="font-sans text-xs font-semibold uppercase tracking-[0.18em] text-gold">Company</h4>
            <ul className="mt-5 space-y-3">
              {COMPANY_LINKS.map((c) => (
                <li key={c.label}>
                  <Link to={c.to} className="font-sans text-sm transition-colors hover:text-white" style={{ color: "var(--pt-muted-on-navy)" }}>
                    {c.label}
                  </Link>
                </li>
              ))}
            </ul>
            <a
              href={`mailto:${COMPANY.email}`}
              className="mt-6 inline-flex items-center gap-2 font-sans text-sm font-semibold text-gold-soft hover:text-white transition-colors"
            >
              Email Us <ArrowRight size={15} />
            </a>
          </div>
        </div>

        <GoldDivider className="my-10" />

        <div className="flex flex-col items-center justify-center gap-3 sm:flex-row">
          <p className="font-sans text-xs" style={{ color: "rgba(255,255,255,0.55)" }}>
            © {new Date().getFullYear()} Prince Trading Impex. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
